import apiRequest from '@/utils/apiRequest';

/**
 * CQ 公开配置
 */
export interface CqPublicConfig {
  enabled: boolean;
  defaultLang: string;
  showLobbyLink: boolean;
}

/**
 * CQ 游戏项
 */
export interface CqGameItem {
  gamecode: string;
  gamehall: string;
  name: string;
  iconUrl?: string;
  gametype: string;
}

/**
 * 获取 CQ 公开配置
 */
export async function getCqConfig(): Promise<CqPublicConfig> {
  return apiRequest<CqPublicConfig>('/public/cq/config', {
    method: 'GET',
  });
}

/**
 * 获取 CQ 游戏列表
 */
export async function getCqGameList(): Promise<CqGameItem[]> {
  return apiRequest<CqGameItem[]>('/public/cq/games', {
    method: 'GET',
  });
}

/**
 * 获取游戏启动链接
 */
export async function getGameLink(gamecode: string, gamehall: string, clientOrigin: string, lang?: string): Promise<string> {
  const response = await apiRequest<{ url: string }>('/cq/getGameLink', {
    method: 'POST',
    data: { gamecode, gamehall, lang, clientOrigin },
  });
  return response.url;
}

/**
 * 获取游戏大厅链接
 */
export async function getLobbyLink(clientOrigin: string, lang?: string): Promise<string> {
  const response = await apiRequest<{ url: string }>('/cq/getLobbyLink', {
    method: 'POST',
    data: { lang, clientOrigin },
  });
  return response.url;
}

// CQ9 投注记录
export interface CqTransactionRecord {
  id: string;
  mtcode: string;
  account: string;
  roundid: string;
  userId: number;
  txType: string;
  gamehall: string;
  gamecode: string;
  amount: number;
  balanceBefore: number;
  balanceAfter: number;
  currency: string;
  eventTime: string;
  createTime: string;
  createDate: string;
}

interface PageResult<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export async function getCqTransactions(params?: {
  page?: number;
  pageSize?: number;
}): Promise<PageResult<CqTransactionRecord>> {
  return apiRequest<PageResult<CqTransactionRecord>>('/cq/transactions', {
    method: 'POST',
    data: {
      page: params?.page ?? 0,
      pageSize: params?.pageSize ?? 20,
    },
  });
}

// CQ9 注单汇总
export interface CqBetSummaryRecord {
  id: string;
  roundid: string;
  gamehall: string;
  gamecode: string;
  gameName?: string;
  iconUrl?: string;
  currency: string;
  betAmount: number;
  winAmount: number;
  transferAmount: number;
  endRound: boolean;
  transactionCount: number;
  createDate: string;
}

export async function getCqBetSummaries(params?: {
  page?: number;
  pageSize?: number;
}): Promise<PageResult<CqBetSummaryRecord>> {
  return apiRequest<PageResult<CqBetSummaryRecord>>('/cq/betSummaries', {
    method: 'POST',
    data: {
      page: params?.page ?? 0,
      pageSize: params?.pageSize ?? 20,
    },
  });
}

export async function getCqBetSummaryTransactions(roundid: string): Promise<CqTransactionRecord[]> {
  return apiRequest<CqTransactionRecord[]>(`/cq/betSummary/transactions?roundid=${encodeURIComponent(roundid)}`, {
    method: 'POST',
  });
}
